/**
 * CBD HUT — Dosage Calculator
 * Extracted from sections/dosage-calculator.liquid
 *
 * Behaviour:
 * - Click button to calculate recommended daily dose (mg)
 * - After first calculation, updates live on weight/strength changes
 * - Supports Theme Editor section reloads (shopify:section:load)
 */

(function () {
  'use strict';

  if (window.CBH_DOSAGE_CALCULATOR_LOADED) return;
  window.CBH_DOSAGE_CALCULATOR_LOADED = true;

  function clamp(n, min, max) {
    return Math.min(max, Math.max(min, n));
  }

  function formatDose(mg) {
    var s = (Number(mg) || 0).toFixed(1).replace(/\.0$/, '');
    return s + 'mg CBD per day';
  }

  function initOne(sectionEl) {
    if (!sectionEl || sectionEl.dataset.cbhDosageInit === '1') return;
    sectionEl.dataset.cbhDosageInit = '1';

    var weightInput = sectionEl.querySelector('[data-cbd-weight]');
    var strengthSelect = sectionEl.querySelector('[data-cbd-strength]');
    var button = sectionEl.querySelector('[data-cbd-calc]');
    var resultEl = sectionEl.querySelector('[data-cbd-result]');
    var noteEl = sectionEl.querySelector('[data-cbd-note]');

    if (!weightInput || !strengthSelect || !button || !resultEl || !noteEl) return;

    var hasCalculated = false;

    // Simple guideline factors (mg per kg)
    var factors = {
      low: 0.5,
      medium: 1.0,
      high: 1.5
    };

    function calculateDose() {
      var weight = parseFloat(weightInput.value);

      if (isNaN(weight) || weight <= 0) {
        resultEl.textContent = 'Please enter a valid weight in kilograms.';
        noteEl.textContent = '';
        return;
      }

      var strength = String(strengthSelect.value || 'medium');
      var factor = factors[strength] || factors.medium;

      var dose = weight * factor;

      // Clamp to a reasonable range
      dose = clamp(dose, 5, 300);

      resultEl.textContent = formatDose(dose);
      noteEl.textContent =
        'Use this as a starting point and adjust slowly every few days based on how you feel.';
      hasCalculated = true;
    }

    // Primary action
    button.addEventListener('click', calculateDose);

    // Enter key on the weight field
    weightInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        calculateDose();
      }
    });

    // Live updates only after first calculation (keeps UX predictable)
    weightInput.addEventListener('input', function () {
      if (hasCalculated) calculateDose();
    });

    strengthSelect.addEventListener('change', function () {
      if (hasCalculated) calculateDose();
    });
  }

  function initAll(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll('[data-cbh-dosage-calculator]');
    if (!sections || !sections.length) return;
    sections.forEach(function (el) {
      initOne(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  // Theme Editor support
  document.addEventListener('shopify:section:load', function (event) {
    if (!event || !event.target) return;
    initAll(event.target);
  });
})();
